import React, { useCallback, useState } from "react";
import { Col, Container } from "reactstrap";
import { retrieveCustomerUpdateRequestsList } from "utils/api";
import { defaultNgiErrorMethod, warnMessage } from "components/Common/responses/message";
import NGITable from "components/Common/NGITable";
import useStoreFilters from "customHooks/useStoreFilters";
import { FILTER_PAGE, USER_ROLES } from "utils/constants";
import { customerUpdateListColumns } from "pages/customer-management/customerUpdateRequest/customerUpdateListColumns";
import CustomerUpdateSearch from "pages/customer-management/customerUpdateRequest/CustomerUpdateSearch";
import CustomButton from "components/Common/buttons/CustomButton";
import CustomLink from "components/Common/buttons/CustomLink";
import { STATUSES } from "pages/customer-management/customerUpdateRequest/constants";

const CustomerUpdateRequests = () => {
  const [isLoading, setLoader] = useState(false);
  const [requestList, setRequestList] = useState(null);
  const { setFilters } = useStoreFilters(FILTER_PAGE.CUSTOMER_UPDATE_REQUESTS);

  const onListLoaded = useCallback(res => {
    const {
      result: { items },
    } = res?.data;
    if (items?.length === 0) {
      warnMessage("Customer Update Requests were not found");
    }
    setRequestList(res?.data || null);
    setLoader(false);
  }, []);

  const handleSearch = (filterOptions = {}) => {
    setLoader(true);
    setFilters(filterOptions);

    retrieveCustomerUpdateRequestsList({
      ...filterOptions,
    })
      .then(res => onListLoaded(res))
      .catch(err => {
        setLoader(false);
        setRequestList(null);
        defaultNgiErrorMethod(err);
      });
  };

  return (
    <>
      <div className="page-content">
        <Container fluid>
          <div className="filters-wrapper">
            <div className="filter-buttons">
              <CustomLink to={`/customers/create-update-request`}>
                <CustomButton
                  icon={<i className="bx bx-plus-circle" />}
                  roles={[
                    USER_ROLES.A_SM,
                    USER_ROLES.OPERATION_MANAGERS,
                    USER_ROLES.CUSTOMER_CARE,
                    USER_ROLES.CX_INTEGRATION,
                  ]}
                  type="primary"
                  text="NEW REQUEST"
                />
              </CustomLink>
            </div>
            <CustomerUpdateSearch statuses={STATUSES} handleSearch={handleSearch} />
          </div>
          <Col lg={12}>
            <NGITable
              filtersType={FILTER_PAGE.CUSTOMER_UPDATE_REQUESTS}
              rowKey={record => record.id}
              isLoading={isLoading}
              columns={customerUpdateListColumns()}
              data={requestList}
              updateList={handleSearch}
            />
          </Col>
        </Container>
      </div>
    </>
  );
};

export default CustomerUpdateRequests;
